<!--
Author: TangChen
Date: 2018-09-19
Desc: 协议内容
-->
<template>
    <div class="comp-risk-ques comp">
        <el-row class="risk-test">
            <el-col class="risk-tit" :span="24">
                <div class="risk-tit-box">
                    <i class="risk-icon" />
                    <span>为了给您提供个性化的理财服务，我们需要对您的理财需求倾向进行评估，烦请完成如下问题，提交之后我们会向您公布测试结果。请仔细阅读下面题目，选出每个题目中最适合您的选项。</span>
                </div>
            </el-col>
            <el-col class="risk-ques" :span="24">
                <p class="ques-tit">
                    <span>{{ index }}</span>/{{ riskQuestions.length }}
                </p>
                <div class="ques-box">
                    <div class="ques-list">
                        <p class="ques-text">
                            {{ doQuestion.questionname }}
                        </p>
                        <el-radio-group v-if="doQuestion.multselect==='0'" v-model="answer">
                            <el-radio v-for="(an,_x) in doQuestion.ansList" :key="_x" :label="an.result">
                                {{ /[a-zA-Z]+$/.test(an.resultcontent.substr(0,2))?an.resultcontent:(an.result+'、'+an.resultcontent) }}
                            </el-radio>
                        </el-radio-group>
                        <el-checkbox-group v-if="doQuestion.multselect==='1'" v-model="answerArr">
                            <el-checkbox
                                v-for="(an,_y) in doQuestion.ansList"
                                :key="_y"
                                :label="an.result"
                            >
                                {{ an.resultcontent }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                    <el-row class="ques-next">
                        <el-pagination
                            background
                            :current-page.sync="index"
                            :page-size="1"
                            prev-text="上一题"
                            next-text="下一题"
                            layout="prev, next"
                            :total="riskQuestions.length"
                            v-on:current-change="questionRefresh"
                        />
                    </el-row>
                    <el-row v-if="riskQuestions.length>0" class="answer-list">
                        <el-col v-for="(list,_z) in riskQuestions" :key="_z" :span="12">
                            <div v-on:click="questionRefresh(_z+1)">
                                {{ _z+1 }}. <span>{{ list.key }}</span>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <!-- <div class="agree-content">
                    <el-checkbox v-model="checked">
                    </el-checkbox>
                    <span>本人已仔细阅读贵司的<a class="notice-read" v-on:click.prevent="read()">《投资者类型及风险匹配告知书》</a>，已充分知晓并理解贵司对本人的风险承受能力评估及产品等级匹配结果，本人对此没有异议。
                        <br />本人承诺，将及时、如实地向贵司告知本人的重大信息变更。
                    </span>
                </div> -->
                <div class="ques-btn">
                    <el-button type="primary" class="medium" v-on:click="submitForm()">
                        提交问卷
                    </el-button>
                </div>
            </el-col>
        </el-row>
        <el-dialog title="提示" :visible.sync="tpasswdDialogVisible" class="prop info-tips" width="480px">
            <div class="investor-tips">
                <div class="prompt-info">
                    <p><i class="el-icon-warning" /><span>普通投资者转专业投资需要密码校验</span></p>
                </div>
                <el-form
                    ref="ruleForm"
                    class="two-cols-form"
                    :model="ruleForm"
                    :rules="rules"
                    label-width="37px"
                    size="small"
                >
                    <el-form-item label="" prop="tpasswd">
                        <el-input
                            v-model="ruleForm.tpasswd"
                            type="password"
                            :maxlength="20"
                            placeholder="请输入交易密码"
                        />
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button v-on:click="tpasswdDialogVisible = false">
                    返回
                </el-button>
                <el-button type="primary" v-on:click="cancelConfirm">
                    确定
                </el-button>
            </div>
        </el-dialog>
        <el-dialog
            :title="(data.risk?'风险':'知识')+'评测提示'"
            :visible.sync="dialogVisible"
            class="prop"
            width="420px"
        >
            <div class="info-box">
                <el-alert :title="msg" type="warning" show-icon :closable="false" />
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button v-if="passflag==='0'" v-on:click="$router.push({name:'info'})">
                    信息中心
                </el-button>
                <el-button type="primary" v-on:click="dialogVisible = false">
                    {{ btnMsg }}
                </el-button>
            </div>
        </el-dialog>
        <el-dialog
            title="投资者类型及风险匹配告知书"
            :visible.sync="noticeDialogVisible"
            :fullscreen="true"
        >
            <div>
                尊敬的投资者：<br /><br />
                &emsp;&emsp;公开募集证券投资基金或私募资产管理计划（以下统称“产品”）是一种长期投资工具，其主要功能是分散投资，降低投资单一证券所带来的个别风险。产品不同于银行储蓄、国债等能够提供固定收益预期的金融工具，其投资运作过程中可能会面临各种风险，如市场风险、信用风险、流动性风险等，因此投资运作既可能产生收益，也可能产生损失（本金亏损或超过原始本金损失）。一般来说，产品的收益预期越高，投资者承担的风险也越大。由于与产品有关的文本（如产品合同、产品说明书/招募说明书（更新）、公告等）除明确产品投资范围、投资限制等还可能存在解除合同等限制性条款或对投资者行使权力有相关要求。因此，敬请投资者投资产品前认真阅读拟投资产品的产品合同、产品说明书/招募说明书、公告等与产品有关的文本，充分了解投资者的权利、义务以及该产品的风险收益特征，根据自身投资目的、风险偏好、投资经验及风险承受能力审慎选择适合自己的产品。<br />
                &emsp;&emsp;产品投资过程中除面临上述风险外，对于开放式或定期开放式产品，其运营过程中还会面临特有的巨额赎回风险，即当单个交易日产品的净赎回申请超过产品总份额一定比例时，将无法及时满足所有投资者的赎回申请。敬请投资者根据其投资期限、资产状况等判断此类产品是否与自己的风险承受能力相适应。此外，管理人业务或财务状况的变化，也可能对投资运作产生不利影响，从而使投资者承受因此产生的投资损失。敬请投资者审慎选择管理人，避免因管理人原因而影响自身合理判断。<br />
                &emsp;&emsp;本公司坚持投资者利益优先原则，在销售产品的过程中将基于投资者的不同风险承受能力以及产品的不同风险等级等因素，提出明确的适当性匹配意见。本公司的适当性匹配意见不表明对产品的风险和收益做出实质性判断或者保证。本公司提醒投资者产品投资的“卖者尽责，买者自负”原则，在做出投资决策后，产品运营状况与产品净值变化引致的投资风险，由投资者自行负担。<br />
                &emsp;&emsp;本风险告知函的揭示事项仅为列举性质，未能详尽列明投资者投资产品所面临的全部风险和可能导致投资者资产损失的所有因素。投资者应当认真阅读《基金合同》、《招募说明书》、《产品资料概要》或《私募资产管理合同》、《私募资产管理计划说明书》等法律文件，充分了解产品情况及风险收益特征，听取本公司适当性匹配意见的基础上，请投资者根据自身风险承受能力审慎决策，独立承担投资风险。<br />
                &emsp;&emsp;本公司作为管理人承诺以诚实信用、勤勉尽责的原则管理和运用产品资产，但不保证产品一定盈利，也不保证最低收益。产品的过往业绩及其净值高低并不预示其未来业绩表现。
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" v-on:click="makesureSubmit()">
                    我已阅读并知晓
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: "RiskQues",
    props: {
        data: {
            type: Object,
            default: function () {
                return {
                    risk: true,
                    url: "risk"
                };
            }
        },
        fn: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            dialogVisible: false,
            agree: "",
            answer: "",
            answerArr: [],
            btnMsg: "",
            index: 1,
            query: null, // 定时器对象
            riskQuestions: [],
            doQuestion: {},
            msg: "",
            passflag: "",
            checked: true,
            noticeDialogVisible: false,
            // 密码校验
            ruleForm: {
                tpasswd: ""
            },
            rules: {
                tpasswd: [
                    { required: true, message: "请输入交易密码", trigger: "blur" }
                ]
            },
            tpasswdDialogVisible: false
        };
    },
    watch: {
        answer (val) { // 监听答案更新数据
            if (val && val !== "") {
                const _this = this;
                if (this.index < this.riskQuestions.length && val !== this.riskQuestions[this.index - 1].key) { // 自动跳到下一题
                    this.query = setTimeout(function () {
                        _this.questionRefresh(_this.index + 1);
                    }, 100);
                }
                this.$set(this.riskQuestions[this.index - 1], "key", val);
            }
        },
        answerArr (val) {
            if (val && val.length > 0) {
                this.$set(this.riskQuestions[this.index - 1], "key", val.join(","));
            }
        }
    },
    created () {
        this.getRisks();
    },
    methods: {
        submitForm () {
            const _this = this;
            let _notDo = [];
            for (let _x in this.riskQuestions) {
                const _r = this.riskQuestions[_x].key;
                if (!_r) {
                    _notDo.push(Number(_x) + 1);
                }
            }
            if (_notDo.length > 0) {
                this.msg = "您还有第" + _notDo.join(",") + "题(共" + _notDo.length + "题)没有回答!";
                this.btnMsg = "我已知晓";
                this.dialogVisible = true;
            } else {
                //this.noticeDialogVisible = true;
                this.makesureSubmit();
            }
        },
        makesureSubmit () {
            const _this = this;
            let allResult = "";
            let allPoint = "";
            _this.noticeDialogVisible = false;
            for (let _x in this.riskQuestions) {
                const _r = this.riskQuestions[_x].key;
                if (_r) {
                    allResult += this.riskQuestions[_x].questioncode + ":" + _r + "|";
                    const _a = this.riskQuestions[_x].ansList;
                    let point = [];
                    for (let _z in _a) {
                        if (_r.indexOf(_a[_z].result) > -1) {
                            point.push(_a[_z].resultpoint);
                        }
                    }
                    allPoint += point.join(",") + "|";
                }
            }
            const reqUrl = "acct/" + (this.data.risk ? "risksurvey" : "changetype") + "/answer";
            this.$util.request(reqUrl, { answer: allResult.substr(0, allResult.length - 1), pointlist: allPoint.substr(0, allPoint.length - 1), papercode: this.riskQuestions[0].papercode, iscontinue: "1" }, "POST").then(res => {
                if (res.data) {
                    if (_this.data.risk) {
                        const info = _this.$cache.getUser();
                        info.riskexpired = "0";
                        info.custrisk = res.data[0].risklevel;
                        info.lowriskflag = res.data[0].lowriskflag;
                        _this.$store.dispatch("setInfo", info).then(() => {
                            if (_this.fn) { _this.$emit("fn-back", false); } else {
                                _this.$router.push({ name: _this.data.url, query: { iswarn: res.data[0].iswarn } });
                            }
                        });
                    } else {
                        _this.passflag = res.data[0].passflag;
                        if (_this.passflag === "1") {
                            if (_this.$cache.getPwdCheck("P2")) {
                                _this.ruleForm.tpasswd = "";
                                _this.tpasswdDialogVisible = true;
                            }else {
                                _this.toProfessional();
                            }
                        } else {
                            _this.msg = "您的投资者知识评测未达到要求";
                            _this.btnMsg = "重新评测";
                            _this.dialogVisible = true;
                        }
                    }
                }
            });
        },
        cancelConfirm () {
            var _this = this;
            _this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    _this.tpasswdDialogVisible = false;
                    _this.toProfessional();
                }else {
                    return false;
                }
            });
        },
        toProfessional () {
            var _this = this;
            this.$util.request("acct/changetype/ordinary2professional", {"tradepwd": _this.$util.enc(_this.ruleForm.tpasswd)}, "POST").then(res => {
                if (res.data) {
                    _this.ruleForm.tpasswd = "";
                    _this.$router.push({name: _this.data.url});
                }
            });
        },
        // 刷新题目数据
        questionRefresh (val) {
            /* if(this.index === val){
                    return;
                } */
            clearTimeout(this.query);
            this.index = val;
            const _d = this.riskQuestions[this.index - 1];
            this.doQuestion = _d;
            this.answer = _d ? _d.key : "";
            this.answerArr = _d && _d.key && _d.key.length > 0 ? _d.key.split(",") : [];
        },
        // 获取题目信息
        getRisks () {
            const _this = this;
            const reqUrl = "acct/" + (this.data.risk ? "risksurvey" : "changetype") + "/question";
            this.$util.request(reqUrl).then(res => {
                if (res.data) {
                    let _obj = {};
                    // 整理题目数据格式
                    for (let arr of res.data) {
                        if (_obj[arr.questioncode]) {
                            let _d = {
                                result: arr.result,
                                resultcontent: arr.resultcontent,
                                resultpoint: arr.resultpoint
                            };
                            for (let _x of _this.riskQuestions) {
                                if (_x.questioncode === arr.questioncode) {
                                    _x.ansList.push(_d);
                                }
                            }
                        } else {
                            _obj[arr.questioncode] = true;
                            let _d = {
                                result: arr.result,
                                resultcontent: arr.resultcontent,
                                resultpoint: arr.resultpoint
                            };
                            arr.ansList = [];
                            arr.ansList.push(_d);
                            _this.riskQuestions.push(arr);
                        }
                    }
                    _this.questionRefresh(_this.index);
                }
            });
        }
    }
};
</script>
<style lang="scss">
    @import "../../assets/css/varibles";
    .comp-risk-ques {
    .risk-test {
    .el-pagination span:not([class*="suffix"]),
    .el-pagination button {
        height: 32px;
        width: 68px;
        line-height: 32px;
        background: transparent;
        border-radius: 3px;
    }
    .el-pagination {
        padding: 0;
    }
    .el-pagination button {
        border: 1px solid $text-color10;
    &:first-of-type {
         margin-left: 0;
     }
    &.btn-prev {
    &:hover,
    &:focus {
         border-color: $color-a;
         color: $color-a;
     }
    &:disabled {
         color: $text-color10;
         border-color: $text-color10;
     }
    }
    &.btn-next {
         color: $color-a;
         background: $color-a-l;
         border-color: $color-a-ld;
    &:hover,
    &:focus {
         border-color: $color-a;
         background: $color-a;
         color: $text-color6;
     }
    &:disabled {
         color: $text-color10;
         border-color: $text-color10;
     }
    }
    }
    padding: 0 20px;
    .risk-tit {
        margin: 20px 0 10px;
    .risk-tit-box {
        background-color: $bg10;
        border: 1px solid $border-color6;
        padding: 8px 10px;
    .risk-icon {
        width: 42px;
        height: 48px;
        display: inline-block;
        vertical-align: middle;
        background: url($icon) -297px -122px no-repeat;
        margin-right: 13px;
    }
    span {
        display: inline-block;
        vertical-align: middle;
        line-height: 24px;
        color: $text-color3;
        width: 1076px;
    }
    }
    }
    .risk-ques {
    .ques-tit {
    span {
        font-size: $f30;
        color: $color-b;
    }
    font-size: $f18;
    color: $text-color1;
    line-height: 40px;
    }
    .ques-tit,
    .ques-box {
        border-bottom: 1px solid $border-color8;
    }
    .ques-next {
        margin: 10px 0 20px 24px;
    }
    .ques-box {
        position: relative;
    .answer-list {
        width: 200px;
        position: absolute;
        top: 13%;
        right: 5%;
        background-color: $color-a-l;
        padding: 10px;
        border-radius: 6px;
        font-size: $f16;
        color: $text-color3;
    .el-col {
        line-height: 26px;
        cursor: pointer;
        border-radius: 3px;
        padding: 0 4px;
    span {
        color: $color-b;
    }
    &:hover {
         background-color: $color-a-ld;
     }
    }
    }
    .ques-list {
        padding: 10px 0;
        color: $text-color2;
    .ques-text {
        font-size: $f16;
        line-height: 36px;
    }
    .el-radio-group,
    .el-checkbox-group {
        margin: 7px 0 10px 24px;
    .el-radio,
    .el-checkbox {
        display: block;
    }
    .el-radio + .el-radio,
    .el-checkbox + .el-checkbox {
        margin-left: 0;
        margin-top: 9px;
    }
    }
    }
    }
    .ques-btn {
        padding: 10px 0 0 24px;
    .el-checkbox-group {
        margin: 10px 0;
    }
    }
    .agree-content {
        padding: 15px 20px;
    >label {
        margin-right: 7px;
    }
    .notice-read {
        cursor: pointer;
    }
    }
    }
    }
    }
</style>
